var map = {
	"./Slide1.PNG": 2429,
	"./Slide10.PNG": 9561,
	"./Slide11.PNG": 5888,
	"./Slide12.PNG": 4139,
	"./Slide13.PNG": 6946,
	"./Slide14.PNG": 8349,
	"./Slide15.PNG": 2420,
	"./Slide16.PNG": 2655,
	"./Slide17.PNG": 1622,
	"./Slide18.PNG": 7937,
	"./Slide19.PNG": 5432,
	"./Slide2.PNG": 5238,
	"./Slide20.PNG": 6436,
	"./Slide21.PNG": 6813,
	"./Slide22.PNG": 5382,
	"./Slide23.PNG": 7215,
	"./Slide24.PNG": 6144,
	"./Slide25.PNG": 9209,
	"./Slide26.PNG": 3618,
	"./Slide27.PNG": 283,
	"./Slide28.PNG": 8556,
	"./Slide3.PNG": 7823,
	"./Slide4.PNG": 5088,
	"./Slide5.PNG": 8169,
	"./Slide6.PNG": 434,
	"./Slide7.PNG": 4315,
	"./Slide8.PNG": 2140,
	"./Slide9.PNG": 6725
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3059;